export function getRelativeDimensions(activeScreenDimension: number | undefined, input: string): string {
  const inputUnit = input.replace(/\d/g, '');
  const ignoreUnitTypes = ['px', 'rem', 'em'];
  if (!activeScreenDimension || ignoreUnitTypes.includes(inputUnit)) {
    return input;
  }
  const inputValue = parseInt(input.replace(/[^\d.-]/g, ''));
  return `${(activeScreenDimension * inputValue) / 100}px`;
}
